import type { IconData } from '@stacksjs/iconify-core'

export const invisible1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M37 36.75a22.03 22.03 0 0 0 8.2-11.85a3.37 3.37 0 0 0 0-1.801C42.62 13.814 34.106 7 24 7a21.9 21.9 0 0 0-12.652 4M32 39.5c-2.48.968-5.178 1.5-8 1.5c-10.107 0-18.622-6.814-21.2-16.099a3.37 3.37 0 0 1 0-1.802A21.9 21.9 0 0 1 7.028 15\"/><path d=\"M31.142 31A9.97 9.97 0 0 0 34 24c0-5.523-4.477-10-10-10a9.97 9.97 0 0 0-7.141 3M3 3l42 42\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default invisible1
